import React from "react"
import { removeDoubleSlash } from "../../../shared/utils/urlUril"
import useMediaQuery from "../../../shared/utils/useMediaQuery"
// import { Link } from "gatsby"

import "./article-item.scss"

export default function ArticleItem({ getDate, item, iStart, iEnd, news, dataLayer }) {
  const isMobile = useMediaQuery()
  if (news) {
    return item.map((info, index) => {
      if (index >= iStart && index <= iEnd) {
        return (
          <div
            key={index}
            className={
              "f-carousel-the-new-item f-carousel-the-new-pos-" + index
            }
          >
            <a 
              href={removeDoubleSlash("/magazin/nuestro-mundo/" + info.slug)}
              onClick={(e) =>{
                 dataLayer && dataLayer(info)
                }}
            >
              {isMobile ? (
                <img
                  className="f-carousel-the-new-imagen"
                  loading="lazy"
                  alt={info.imagenArticuloMiniatura.description}
                  src={info.imagenArticuloMiniatura.file.url}
                  height={info.imagenArticuloMiniatura.file.details.image.height}
                  width={info.imagenArticuloMiniatura.file.details.image.width}
                />
              ) :
                (
                  <img
                    className="f-carousel-the-new-imagen"
                    alt={info.imagenArticuloMiniatura.description}
                    src={info.imagenArticuloMiniatura.file.url}
                    height={info.imagenArticuloMiniatura.file.details.image.height}
                    width={info.imagenArticuloMiniatura.file.details.image.width}
                  />
                )}
            </a>

            <div>
              <span
                className={
                  "f-carousel-the-new-category " +
                  (info.categorias[0].slug === "articulos-usuarias"
                    ? "f-user-article"
                    : "")
                }
              >
                {info.categorias[0].titulo}
              </span>
              <a
                className="f-carousel-the-new-link"
                href={"/magazin/nuestro-mundo/" + info.slug}
                onClick={(e) =>{
                   dataLayer && dataLayer(info)
                  }}
              >
                <h3>{info.tituloArticulo}</h3>
              </a>
              {info.fechaDePublicacion && (
                <p className="f-carousel-the-new-date">
                  {getDate(info.fechaDePublicacion)}
                </p>
              )}
            </div>
          </div>
        )
      }

      return ""
    })
  } else {
    return item.map((info, index) => {
      if (index >= iStart && index <= iEnd) {
        return (
          <div
            key={index}
            className={
              "f-carousel-female-care-item f-carousel-female-care-pos-" + index
            }
          >
            <a 
              href={removeDoubleSlash("/entre-nosotras/" + info.slug)}
                onClick={(e) =>{
                   dataLayer && dataLayer(info)
                  }}
            >
              {isMobile ? (
                <img
                  className="f-carousel-female-care-imagen"
                  loading="lazy"
                  alt={info.imagenArticuloMiniatura.description}
                  src={info.imagenArticuloMiniatura.file.url}
                />
              ) : (
                <img
                  className="f-carousel-female-care-imagen"
                  alt={info.imagenArticuloMiniatura.description}
                  src={info.imagenArticuloMiniatura.file.url}
                />
              )}
            </a>
            <div>
              <span className="f-carousel-female-care-category">
                {info.categorias[0].titulo}
              </span>
              <a
                className="f-carousel-female-care-link"
                href={removeDoubleSlash("/entre-nosotras/" + info.slug)}
                onClick={(e) =>{
                   dataLayer && dataLayer(info)
                  }}
              >
                <h3>{info.tituloArticulo}</h3>
              </a>
              <p className="f-carousel-female-care-description">
                {info.descripcionArticulo}
              </p>
            </div>
          </div>
        )
      }
      return ""
    })
  }
}